import React, { useState } from 'react';
import Menu, { TriggerProps } from '../../../shared/Menu/Menu';
import MenuItem from '../../../shared/Menu/MenuItem';
import excelIcon from '../../../../static/icons/documentsType/excel.svg';
import Button from '../../../shared/SmallComponents/Button';
import ArrayToExcelModal from '../../../shared/ArrayToExcel/ArrayToExcelModal';
import { ModalTriggerProps } from '../../../shared/Modal/Modal';
import { ColumnType } from '../../../shared/Grid/types/Column';
import Tooltip from '@mui/material/Tooltip';

type ConsolidationRow = {
    id: string;
    master: string;
    handlingAgent: string;
    shipmentCount: number;
    route: string;
    flightOrVoyage: string;
    etd?: Date;
    eta?: Date;
    totalWeight: number;
    totalVolume: number;
    status: string;
    isActive: boolean;
    operationalStatus: 'OPEN' | 'CLOSED';
};

type Props = {
    rows: ConsolidationRow[];
    columns: Array<ColumnType<ConsolidationRow>>;
    localization: any;
};

const ConsolidationsExportMenu = ({ rows, columns, localization }: Props) => {
    const [isModalOpened, setIsModalOpened] = useState(false);
    const exportData = rows.map((row) => {
        const out: Record<string, unknown> = {};
        columns.forEach((col) => {
            if (col.field) out[col.field] = (row as Record<string, unknown>)[col.field];
        });
        return out;
    });

    return (
        <Menu
            position="bottom-center"
            arrowOnTrigger={false}
            isModalOpened={isModalOpened}
            options={[
                <ArrayToExcelModal<Record<string, unknown>>
                    key="excel"
                    localization={{
                        ...(localization?.grid?.columns || {}),
                        ...(localization?.exportOptions?.export_excel_modal || {}),
                        title: 'Export consolidations'
                    }}
                    data={exportData}
                    title={localization?.exportOptions?.export_excel_modal?.title || 'Export to Excel'}
                    fileName={localization?.exportOptions?.export_file_name || 'consolidations'}
                    onCancelCallback={() => setIsModalOpened(false)}
                    Trigger={(props: ModalTriggerProps) => (
                        <MenuItem
                            onClick={(e) => {
                                e.stopPropagation();
                                setIsModalOpened(true);
                                props.onClick?.();
                            }}
                            icon={excelIcon}
                            text={localization?.exportOptions?.excel || 'Excel'}
                        />
                    )}
                />
            ]}
            MenuTrigger={(props: TriggerProps) => (
                <Button width="32px" height="32px" borderRadius="50%" margin="7px" buttonType="hollow" onClick={props.onClick}>
                    <Tooltip title={localization?.export_btn || 'Export'} aria-label="export">
                        <span className="material-icons-outlined">file_download</span>
                    </Tooltip>
                </Button>
            )}
        />
    );
};

export default ConsolidationsExportMenu;
